const PARTIAL_CLASS = 'diff-item--partial';
const PRIMARY_CLASS = 'diff-item--primary';

const PARTIAL_POSITION_CLASSES = [
  'diff-item--partial--first',
  'diff-item--partial--middle',
  'diff-item--partial--last',
];

export function normalizeTenantPartialMarkers(deletions) {
  const markers = Array.from(deletions || []);
  if (markers.length < 2) return markers;

  markers.forEach((marker, index) => {
    const position =
      index === 0
        ? PARTIAL_POSITION_CLASSES[0]
        : index === markers.length - 1
        ? PARTIAL_POSITION_CLASSES[2]
        : PARTIAL_POSITION_CLASSES[1];

    marker.setAttribute('diff-partial-index', String(index));
    marker.classList.add(PARTIAL_CLASS, position);
    if (index > 0) marker.classList.remove(PRIMARY_CLASS);
  });

  return markers;
}
